import React from 'react';

const FullRightTriangle = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.66406 4L10.6641 8L6.66406 12V4Z'
        fill='#41415A'
        stroke='#41415A'
        strokeWidth='1.33333'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FullRightTriangle;
